import React, { FC } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import SignIn from "../components/auth/signIn";
import Pin from "../components/auth/pin";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const AuthStack: FC<{ RouteName: "SignIn" | "LoginPin" }> = ({ RouteName }) => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={RouteName}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="SignIn" children={() => <SignIn type="Login" />} />
            <AppStack.Screen name="Register" children={() => <SignIn type="Register" />} />
            <AppStack.Screen name="ForgotPin" children={() => <SignIn type="forgotPin" />} />
            <AppStack.Screen name="ChangePin" children={() => <Pin type="ChangePin" />} />
            <AppStack.Screen name="LoginPin" children={() => <Pin type="loginPin" />} />
        </AppStack.Navigator>
    );
};

export default AuthStack;